import {
    ADD_CAR_TO_BATCH,
    REMOVE_CAR_FROM_BATCH,
    DISABLE_CARS_FROM_BATCH,
    ENABLE_CARS_FROM_BATCH,
    RESET_BATCH,
    CLEAR_ERRORS,
} from './types';

export const addCarToBatch = payload => ({
    type: ADD_CAR_TO_BATCH,
    payload,
});

export const removeCarFromBatch = payload => ({
    type: REMOVE_CAR_FROM_BATCH,
    payload,
});

export const disableCarsFromBatch = payload => ({
    type: DISABLE_CARS_FROM_BATCH,
    payload,
});

export const enableCarsFromBatch = payload => ({
    type: ENABLE_CARS_FROM_BATCH,
    payload,
});

export const resetBatch = () => ({ type: RESET_BATCH });

export const clearErrors = () => ({ type: CLEAR_ERRORS });
